import { render, staticRenderFns } from "./AdminPartnerStatCard.vue?vue&type=template&id=78346a90&scoped=true&"
import script from "./AdminPartnerStatCard.vue?vue&type=script&lang=ts&"
export * from "./AdminPartnerStatCard.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPartnerStatCard.vue?vue&type=style&index=0&id=78346a90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78346a90",
  null
  
)

export default component.exports
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QAvatar,QIcon,QSpace,QBtn,QTooltip});
